import { useContext } from "react";

import { UserContext } from "@context/user";
import AuditLog from "./audit-log";

const ROLE_LABEL = { ops: "Ops Admin", brand: "Brand", publisher: "Publisher" };

const Settings = () => {
    const { userData } = useContext(UserContext);
    const user = userData?.user || {};

    return (
        <div className="p-6">
            <h1 className="text-2xl font-semibold tracking-tight">Settings</h1>
            <p className="mt-1 text-sm text-muted">Ops user account and platform-wide audit log.</p>

            <div className="mt-6 rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
                <p className="text-xs font-semibold uppercase tracking-wide text-muted">Signed in as</p>
                <p className="mt-2 text-lg font-semibold text-gray-900">{user.name}</p>
                <p className="text-sm text-muted">{user.email}</p>
                <p className="mt-3 text-sm text-muted">Role: {ROLE_LABEL[user.role] || user.role}</p>
            </div>

            <div className="mt-4">
                <AuditLog />
            </div>
        </div>
    );
};

export default Settings;
